import {
  ADDRESS_LOADING,
  ADDRESS_SUCCESS,
  ADDRESS_FAILED,
  ADDRESS_ADD_LOADING,
  ADDRESS_ADD_SUCCESS,
  ADDRESS_ADD_FAILED,
  ADDRESS_REMOVE_LOADING,
  ADDRESS_REMOVE_SUCCESS,
  ADDRESS_REMOVE_FAILED,
  ADDRESS_UPDATE_QUESTION_LOADING,
  ADDRESS_UPDATE_QUESTION_SUCCESS,
  ADDRESS_UPDATE_QUESTION_FAILED,
  ADDRESS_SAVE_LOADING,
  ADDRESS_SAVE_SUCCESS,
  ADDRESS_SAVE_FAILED,
  ADDRESS_VALIDATION_LOADING,
  ADDRESS_VALIDATION_SUCCESS,
  ADDRESS_VALIDATION_FAILED,
  ADDRESS_ADD_NEW_LOADING,
  ADDRESS_SAVE_NEW_LOADING,
  ADDRESS_ADD_NEW_SUCCESS,
  ADDRESS_ADD_NEW_FAILED,
  ADDRESS_SAVE_NEW_SUCCESS,
  ADDRESS_SAVE_NEW_FAILED
} from "../Constants/addressConstants";

export const addressReducer = (
  state = { addressData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_LOADING:
      return { loading: true, addressData: [] };
    case ADDRESS_SUCCESS:
      return { loading: false, addressData: action.payload };
    case ADDRESS_FAILED:
      return { loading: false, error: action.addressData };
    default:
      return state;
  }
};


export const addressAddReducer = (
  state = { addressAddData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_ADD_LOADING:
      return { loading: true, addressAddData: [] };
    case ADDRESS_ADD_SUCCESS:
      return { loading: false, addressAddData: action.payload };
    case ADDRESS_ADD_FAILED:
      return { loading: false, error: action.addressAddData };
    default:
      return state;
  }
};


export const addressRemoveReducer = (
  state = { addressRemoveData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_REMOVE_LOADING:
      return { loading: true, addressRemoveData: [] };
    case ADDRESS_REMOVE_SUCCESS:
      return { loading: false, addressRemoveData: action.payload };
    case ADDRESS_REMOVE_FAILED:
      return { loading: false, error: action.addressRemoveData };
    default:
      return state;
  }
};


export const addressUpdateQuestionReducer = (
  state = { addressUpdateQuestionData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_UPDATE_QUESTION_LOADING:
      return { loading: true, addressUpdateQuestionData: [] };
    case ADDRESS_UPDATE_QUESTION_SUCCESS:
      return { loading: false, addressUpdateQuestionData: action.payload };
    case ADDRESS_UPDATE_QUESTION_FAILED:
      return { loading: false, error: action.addressUpdateQuestionData };
    default:
      return state;
  }
};

export const addressSaveReducer = (
  state = { addressSaveData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_SAVE_LOADING:
      return { loading: true, addressSaveData: [] };
    case ADDRESS_SAVE_SUCCESS:
      return { loading: false, addressSaveData: action.payload };
    case ADDRESS_SAVE_FAILED:
      return { loading: false, error: action.addressSaveData };
    default:
      return state;
  }
};


export const addressValidationReducer = (
  state = { addressValidationData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_VALIDATION_LOADING:
      return { loading: true, addressValidationData: [] };
    case ADDRESS_VALIDATION_SUCCESS:
      return { loading: false, addressValidationData: action.payload, record: action.record };
    case ADDRESS_VALIDATION_FAILED:
      return { loading: false, error: action.addressValidationData };
    default:
      return state;
  }
};

export const addressNewSaveReducer = (
  state = { addressNewSaveData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_SAVE_NEW_LOADING:
      return { loading: true, addressNewSaveData: [] };
    case ADDRESS_SAVE_NEW_SUCCESS:
      return { loading: false, addressNewSaveData: action.payload };
    case ADDRESS_SAVE_NEW_FAILED:
      return { loading: false, error: action.addressNewSaveData };
    default:
      return state;
  }
};

export const addressAddNewReducer = (
  state = { addressAddNewData: [] },
  action
) => {
  switch (action.type) {
    case ADDRESS_ADD_NEW_LOADING:
      return { loading: true, addressAddNewData: [] };
    case ADDRESS_ADD_NEW_SUCCESS:
      return { loading: false, addressAddNewData: action.payload };
    case ADDRESS_ADD_NEW_FAILED:
      return { loading: false, error: action.addressAddNewData };
    default:
      return state;
  }
};
